export const CLOSE_TAB_FOOTER = 'PDN/close_tab_footer';
export const OPEN_TAB_FOOTER = 'PDN/open_tab_footer';
export const CHANGE_TAB_MENU = 'PDN/change_tab_menu';
export const CHANGE_PROJECT = 'PDN/change_project';
export const CHANGE_PDN = 'PDN/change_pdn';
export const CLEAN_MONITOR_MSG = 'PDN/clean_monitor_msg';
export const DEBUG_MONITOR = 'PDN/debug_monitor';